// extracted by mini-css-extract-plugin
export default {"header":"Terms_header__5v+by","termsBox":"Terms_termsBox__vlTxo","terms":"Terms_terms__m74jk"};